var React = require('react');

function TwitterGrey (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#323643","fillRule":"nonzero","stroke":"none","strokeWidth":"1","strokeLinecap":"butt","strokeLinejoin":"miter","strokeMiterlimit":"10","strokeDasharray":"","strokeDashoffset":"0","fontFamily":"none","fontWeight":"none","fontSize":"none","textAnchor":"none","style":{"mixBlendMode":"normal"}},React.createElement("g",{"transform":"scale(8.53333,8.53333)"},React.createElement("path",{"d":"M26.37,26l-8.795,-12.822l0.015,0.012l7.93,-9.19h-2.65l-6.46,7.48l-5.13,-7.48h-6.95l8.211,11.971l-0.001,-0.001l-8.66,10.03h2.65l7.182,-8.322l5.708,8.322zM10.23,6l12.34,18h-2.1l-12.35,-18z"}))));
}

TwitterGrey.defaultProps = {"x":"0px","y":"0px","width":"100","height":"100","viewBox":"0,0,256,256"};

module.exports = TwitterGrey;

TwitterGrey.default = TwitterGrey;
